import { ReactNode } from 'react'

import Icon from 'components/common/icon'

import style from './lost.module.scss'

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <div className={style['lost-page']}>
        <div className={style['message-area']}>
          <div className={style['main-content']}>
            {children}
          </div>

        </div>
        <div className={style['links-area']}>
          <div className={style['menu-list']}>
            <div>
              <a href="https://pureskills.com">
                <Icon className={style['icon']} name="home" /> Pagina Inicial
              </a>
            </div>
            <div>
              <a href="https://ajuda.pureskills.com" target="_blank" rel="noreferrer">
                <Icon className={style['icon']} name="help" /> Ajuda
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
